import fetch from './fetch'

export default {
  getFiles (payload) {
    let request = fetch({
      url: `/file`,
      method: 'get',
      data: {},
      payload
    })
    return request.call()
  }
}



// WEBPACK FOOTER //
// ./src/api/file.js